import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import contactComponent from './contact.component';

const contactModule = angular
  .module('contact', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.contact', {
      url: '/contact',
      // resolve: {
      //   contact: ApiService => {
      //     return ApiService.entitySearchOne({
      //       q: 'schema:contact',
      //       include_docs: true,
      //     });
      //   },
      // },
      views: {
        content: {
          component: 'contact',
        },
      },
    });
  })

  .component('contact', contactComponent);

export default contactModule;
